const TokenTypes = [
    { label: 'Live', value: 'LIVE' },
    { label: 'Pretesting', value: 'PRETESTING' },
    { label: 'Review', value: 'REVIEW' }
];

export default TokenTypes;